import {useTranslation} from 'react-i18next';
import {useCurrentPatient} from '@/patient/context/CurrentPatientContext';
import {FullScreenModalTitle} from '@/shared/components/ui/Modal';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';

export default function ModalTitle() {
  const patient = useCurrentPatient();
  const {t} = useTranslation(['shared/common']);
  const {isForClinicalTrials} = useCompany();

  const title = t('shared/common:diagnosticReport.form.newCase', {
    fullname: isForClinicalTrials ? patient.name : patient.fullname
  });

  return <FullScreenModalTitle>{title}</FullScreenModalTitle>;
}
